import type React from 'react';
import { VALIDATION_ERRORS, VALIDATION_ERRORS_ENUM, INPUT_TYPE } from './constants';
import type { Answer, Question, Questionnaire, Error } from './types';
import { isRadio } from './utils';
export const defaultGetErrorMessage = (error: VALIDATION_ERRORS_ENUM): React.ReactNode => {
  return VALIDATION_ERRORS[error];
};
export const validateQuestionnaire = (questionnaire: Questionnaire, answersMap: Map<string, Answer>, getErrorMessage: (error: VALIDATION_ERRORS_ENUM) => React.ReactNode = defaultGetErrorMessage): Error[] => {
  const errors: Error[] = [];
  for (const question of questionnaire.questionList) {
    // Validate question
    const error = validateQuestion(question, answersMap, getErrorMessage);
    if (error) {
      errors.push({
        questionId: question.id,
        errors: [error]
      });
    }
  }
  return errors;
};
export const validateQuestion = (question: Question, answersMap: Map<string, Answer>, getErrorMessage: (error: VALIDATION_ERRORS_ENUM) => React.ReactNode): React.ReactNode | undefined => {
  // Get user answers, defaulting to empty array if question hasn't been answered
  // This treats "no answer entry" the same as "empty answers" for validation purposes
  const userAnswers = answersMap.get(question.id)?.answers ?? [];

  // Checking for required answer
  if (question?.isRequired?.value && userAnswers.length === 0) {
    return getErrorMessage(VALIDATION_ERRORS_ENUM.ANSWER_REQUIRED);
  }

  // Enforce answerLimit only for select dropdowns (not radio)
  // Skip if answerLimit is negative (unlimited options)
  const isSelectDropdown = question.type === INPUT_TYPE.SELECT && !isRadio(question.tags);
  if (isSelectDropdown && question.answerLimit > 0 && userAnswers.length > question.answerLimit) {
    return getErrorMessage(VALIDATION_ERRORS_ENUM.ANSWER_LIMIT_EXCEEDED);
  }
  return;
};